jQuery('.team-arrow').click(function() {
    var person_id = jQuery(this).attr('data-id');
    jQuery.get(
        ajaxurl,
        {
            'action': 'person',
            'data': {'id': person_id}
        }).done(function (data) {
        jQuery("#team-popup .col-md-3 img").attr('src' , '');;
        jQuery("#team-popup h4").empty();
        jQuery("#team-popup .team-title").empty();
        jQuery("#team-popup .team-description").empty();
        // jQuery("#team-popup .team-email").empty();

        jQuery("#team-popup .col-md-3 img").attr('src' , data['thumbnail']);
        jQuery("#team-popup h4").html(data['title']);
        jQuery("#team-popup .team-title").html(data['name']);
        jQuery("#team-popup .team-description").html(data['description']);
        // jQuery("#team-popup .team-email").html(data['email']);
        if( data['email'] ){
            jQuery("#team-popup .team-email").attr('href' , data['email']).show();
        } else {
            jQuery("#team-popup .team-email").hide();
        }
        jQuery('#ModalTeam').modal('show');
    });
});
